import { makeObservable, observable, action } from 'mobx'

class QuoteEntity {
    constructor(id, date, state, customer, type, commissionType, emission, policy, sellerName) {
        this.id = id
        this.date = date
        this.customer = customer
        this.name = `${this.customer.name} ${this.customer.lastName}`
        this.displayName = customer.displayName
        this.state = state
        this.checked = false
        this.type = type
        this.isDisabled = false
        this.commissionType = commissionType
        this.emission = emission
        this.policy = policy
        this.sellerName = sellerName
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false

        makeObservable(this, {
            checked: observable,
            isNewlyAdded: observable,
            isSilentlyUpdated: observable,
            changeCheckedStatus: action,
            setSilentHighlight: action,
            clearSilentHighlight: action,
        })
    }

    changeCheckedStatus() {
        this.checked = !this.checked
    }

    setSilentHighlight({ isNewlyAdded = false, isSilentlyUpdated = false } = {}) {
        this.isNewlyAdded = isNewlyAdded
        this.isSilentlyUpdated = isSilentlyUpdated
    }

    clearSilentHighlight() {
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false
    }

    setVersion(assetLabel) {
        this.fullVersion = assetLabel
    }

    static fromJson({
        id,
        createdAt,
        multiQuoteStatus,
        customer,
        multiQuoteType,
        assetLabel,
        commissionType,
        emission,
        policy,
        sellerName,
    }) {
        const quoteEntity = new QuoteEntity(
            id,
            createdAt,
            multiQuoteStatus,
            customer,
            multiQuoteType,
            commissionType,
            emission,
            policy,
            sellerName
        )

        quoteEntity.setVersion(assetLabel)

        if (multiQuoteStatus === 'cancelled') {
            quoteEntity.isDisabled = true
        }

        return quoteEntity
    }
}

export default QuoteEntity
